"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminService = void 0;
const routes_1 = require("./routes");
class AdminService {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async getOneByNameAndApp(name, app) {
        const result = await this.axiosInstance.get(routes_1.getOneByNameAndAppRoute + name + '/' + app);
        return result.data;
    }
}
exports.AdminService = AdminService;
//# sourceMappingURL=index.js.map